export default "__VITE_ASSET__CEkXUun6__"